import OverviewPage from './OverviewPage';
export default OverviewPage


// WEBPACK FOOTER //
// ./src/pages/OverviewPage/index.tsx